









import { Component, Prop, Vue } from 'vue-property-decorator';
import { uniqueTextInput } from '@/inputs/prompt';
import EditorManager from '@/EditorManager';

@Component
export default class AddNodeButton extends Vue {
  @Prop({ required: true }) readonly node!: string;
  @Prop() readonly name!: string;
  @Prop() readonly options?: unknown;
  @Prop() readonly overviewFlag?: boolean;
  @Prop() readonly names?: Set<string>;

  private editorManager = EditorManager.getInstance();
  private fontSize = 1.0;

  private dragEnd = (event: DragEvent) => {
    if (this.editorManager.canDrop) {
      this.editorManager.enableDrop(false);
      // TODO: When different Node Widths are implemented, centre node on cursor.
      this.addNode(event.pageX - 160, event.pageY - 60);
    }
  };

  created() {
    let factor = (this.name.length - 10) / 3;
    if (factor > 0) {
      if (factor > 3) factor = 3;
      this.fontSize -= 0.18 * factor;
    }
  }

  private onClick() {
    this.addNode(window.innerWidth / 3, window.innerHeight / 3);
  }

  private addNode(x: number, y: number) {
    let name: string | null = null;
    if (this.names) {
      name = uniqueTextInput(this.names, 'Please enter a unique name for the IO');
      if (name === null) return;
    }

    const { editor } = this.$store.getters.currEditorModel;
    const NodeType = editor.nodeTypes.get(this.node);

    if (NodeType === undefined) {
      console.error(`Undefined Node Type: ${this.node}`);
    } else {
      const node = editor.addNode(new NodeType(this.options, this.overviewFlag));

      // Set position (and name) of newly created node
      const { scaling, panning } = EditorManager.getInstance().viewPlugin;
      const { x: xPanning, y: yPanning } = panning;

      node.position.x = (x / scaling) - xPanning;
      node.position.y = (y / scaling) - yPanning;
      if (name) node.name = name;
    }
  }
}
